import PropTypes from "prop-types";
import styles from "./ReportItem.module.css";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import upIcon from "./icons/Trends.png";
import neutralIcon from "./icons/Trends (1).svg";
import downIcon from "./icons/TrendDown.svg";

export function ReportItem({ name, number, trend, color, onClick }) {
  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: color,
        ...(onClick && { cursor: "pointer" }),
      }}
      onClick={onClick ? onClick : () => {}}
    >
      <span className={styles.name}>{name}</span>
      <div className={styles.rightGroup}>
        <span className={styles.number}>{number}</span>
        <div className={styles.iconContainer}>
          <img
            src={
              trend == "up"
                ? upIcon
                : trend == "same"
                ? neutralIcon
                : trend == "down"
                ? downIcon
                : ""
            }
            alt="Trend arrow"
            className={styles.trendIcon}
          />
        </div>
        {onClick && (
          <span className={styles.arrow}>
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
        )}
      </div>
    </div>
  );
}

ReportItem.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  trend: PropTypes.oneOf(["up", "neutral"]).isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ReportItem.defaultProps = {
  color: "#415364",
};
